import React, { Component } from 'react';
import './styles.css';

class Footer extends Component {
	render() {
		return (
			<div className="sales-test-layout-footer">{this.props.children}</div>
		);
	}
}
export default Footer;
